import { createPortal as e } from "react-dom";
// libs/ui-lib/src/lib/embed-portal-container.ts
var t = null;
function n(e) {
	t = e;
}
function r() {
	return t;
}
function i(n, r, i) {
	return e(n, r ?? t ?? document.body, i ?? void 0);
}
export { i as createEmbedPortal, r as getEmbedPortalContainer, n as setEmbedPortalContainer };
